export default "__VITE_PUBLIC_ASSET__62ac7334__"